// extracted by mini-css-extract-plugin
export var numpadContainer = "_s8-1";
export var phoneButton = "_s8-0";